/**
 * Utility to know if something is a string.
 */
export function isString(s) {
    return typeof s === 'string' || s instanceof String;
}
